export default angular.module('cian.newbuild.filter.showOffersService', [])
  .service('ShowOffersService', ['SerpListService', 'FilterService', (SerpListService, FilterService) => {
    const service = {};

    /**
     * Обновляет выдачу по объектам
     * @memberOf ShowOffersService
     */
    service.updateOffers = page => {
      console.log('FilterService.query:', FilterService.query);
      if (page) {
        SerpListService.goToPage(page);
      } else {
        SerpListService.updateOffers(FilterService.query);
      }
    };

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/show-offers.service.js